// Tabella FISSA "Dote Scuola" — contributo regionale, collegata all'alunno via CF.
// Inserimento manuale: cerca l'alunno, poi compila data inserimento e importo.
import { useEffect, useMemo, useRef, useState } from "react";
import api from "@/lib/api";

const todayDmy = () => {
  const d = new Date();
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};
const fmtEuro = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

function AddModal({ onClose, onAdded }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [loading, setLoading] = useState(false);
  const search = async () => {
    if (q.trim().length < 2) return;
    setLoading(true);
    try { const r = await api.get("/dote/alunni-search", { params: { q: q.trim() } }); setRes(r.data?.items || []); }
    catch { setRes([]); } finally { setLoading(false); }
  };
  const pick = async (a) => {
    try {
      const r = await api.post("/dote", { codice_fiscale: a.codice_fiscale, data_inserimento: todayDmy(), importo: 0 });
      onAdded(r.data);
    } catch (e) { alert(e.response?.data?.detail || "Errore inserimento"); }
  };
  return (
    <div data-testid="dote-add-modal" onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "white", width: 520, maxWidth: "95vw", maxHeight: "85vh", borderRadius: 8, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div style={{ background: "#1565c0", color: "white", padding: "12px 16px", display: "flex", justifyContent: "space-between" }}>
          <b>🎓 Aggiungi alunno — Dote Scuola</b>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "white", cursor: "pointer", fontSize: 18 }}>✕</button>
        </div>
        <div style={{ padding: 14 }}>
          <div style={{ display: "flex", gap: 6 }}>
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()}
              data-testid="dote-add-search" placeholder="Cognome Nome o Codice Fiscale…"
              style={{ flex: 1, padding: "8px 10px", border: "1px solid #ccc", borderRadius: 4, fontSize: 13 }} />
            <button onClick={search} data-testid="dote-add-search-btn" style={{ padding: "8px 14px", background: "#1565c0", color: "white", border: "none", borderRadius: 4, fontWeight: 700, cursor: "pointer" }}>Cerca</button>
          </div>
          <div style={{ marginTop: 10, maxHeight: 320, overflowY: "auto", border: "1px solid #eee", borderRadius: 4 }}>
            {loading && <div style={{ padding: 12, color: "#888" }}>Ricerca…</div>}
            {!loading && res.length === 0 && <div style={{ padding: 12, color: "#888", fontSize: 13 }}>Digita e premi Cerca.</div>}
            {res.map((a) => (
              <div key={a.cod} data-testid={`dote-add-opt-${a.cod}`} onClick={() => pick(a)}
                style={{ padding: "8px 12px", borderBottom: "1px solid #f0f0f0", cursor: "pointer", display: "flex", justifyContent: "space-between", gap: 8 }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#e3f2fd"} onMouseLeave={(e) => e.currentTarget.style.background = "white"}>
                <span><b>{a.cognome} {a.nome}</b> <span style={{ color: "#888", fontSize: 12 }}>{a.settore} {a.classe}</span></span>
                <span style={{ fontFamily: "monospace", fontSize: 11, color: "#666" }}>{a.codice_fiscale}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function DoteScuolaPage() {
  const [data, setData] = useState({ items: [], total: 0, totale_importo: 0 });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const [search, setSearch] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const fileRef = useRef(null); // non usato, placeholder per coerenza visuale

  const load = async () => {
    setLoading(true); setErr(null);
    try { const r = await api.get("/dote"); setData(r.data); }
    catch (e) { setErr(e.response?.data?.detail || "Errore caricamento"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const saveField = async (it, field, value) => {
    try {
      const r = await api.put(`/dote/${it.id}`, { [field]: value });
      setData((d) => ({ ...d, items: d.items.map((x) => x.id === it.id ? r.data : x) }));
    } catch (e) { alert("Errore salvataggio: " + (e.response?.data?.detail || e.message)); }
  };
  const del = async (it) => {
    if (!window.confirm(`Eliminare la Dote Scuola di ${it.cognome} ${it.nome}?`)) return;
    try { await api.delete(`/dote/${it.id}`); await load(); }
    catch (e) { alert("Errore: " + (e.response?.data?.detail || e.message)); }
  };

  const rows = useMemo(() => {
    const s = search.trim().toLowerCase();
    return (data.items || []).filter((it) => {
      if (s && !`${it.cognome} ${it.nome} ${it.codice_fiscale || ""}`.toLowerCase().includes(s)) return false;
      return true;
    });
  }, [data, search]);

  const totale = rows.reduce((a, it) => a + Number(it.importo || 0), 0);

  return (
    <div data-testid="dote-scuola-page" style={{ padding: "12px 20px" }}>
      <div className="sw-page-title" style={{ display: "flex", alignItems: "center" }}>
        <h1>🎓 Dote Scuola</h1>
        <div className="sw-breadcrumb">Tabelle Fisse &gt; Dote Scuola</div>
        <button onClick={() => setShowAdd(true)} data-testid="dote-add-btn"
          title="Cerca un alunno e aggiungilo alla Dote Scuola"
          style={{ marginLeft: "auto", padding: "7px 14px", background: "#1565c0", color: "white", border: "none", borderRadius: 3, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          ➕ Aggiungi alunno
        </button>
      </div>

      <div style={{ margin: "8px 0", background: "white", border: "1px solid #ccc", padding: 10, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
        <input placeholder="Cerca alunno, C.F.…" value={search} onChange={(e) => setSearch(e.target.value)}
          data-testid="dote-search" style={{ padding: "5px 10px", border: "1px solid #ccc", fontSize: 12, width: 240 }} />
        <div style={{ marginLeft: "auto", fontSize: 12, color: "#444" }}>
          <b>{data.total}</b> alunni · totale dote <b data-testid="dote-totale">{fmtEuro(data.totale_importo)}</b>
        </div>
      </div>

      {err && <div style={{ margin: "0 0 8px", padding: 10, background: "#fff0f0", border: "1px solid #fcc", color: "#c00", fontSize: 12 }}>{err}</div>}

      <div style={{ background: "white", border: "1px solid #ccc", overflow: "auto", maxHeight: "72vh" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }} data-testid="dote-table">
          <thead style={{ background: "#1565c0", color: "white", position: "sticky", top: 0, zIndex: 1 }}>
            <tr>
              <th style={{ padding: "6px 8px", textAlign: "center", width: 30 }}>#</th>
              <th style={{ padding: "6px 8px", textAlign: "left" }}>ALUNNO</th>
              <th style={{ padding: "6px 8px", textAlign: "left", width: 100 }}>SETT./CLASSE</th>
              <th style={{ padding: "6px 8px", textAlign: "center", width: 140 }}>DATA INSERIMENTO</th>
              <th style={{ padding: "6px 8px", textAlign: "right", width: 130 }}>IMPORTO DOTE</th>
              <th style={{ padding: "6px 8px", textAlign: "center", width: 80 }}>AZIONI</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} style={{ padding: 20, textAlign: "center", color: "#888" }}>Caricamento…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessuna dote. Usa <b>➕ Aggiungi alunno</b>.</td></tr>}
            {!loading && rows.map((it, i) => (
              <tr key={it.id} data-testid={`dote-row-${i}`} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "5px 8px", textAlign: "center", color: "#888", fontFamily: "monospace" }}>{i + 1}</td>
                <td style={{ padding: "5px 8px", fontWeight: 600, textTransform: "uppercase" }}>
                  {it.collegato ? <span>{it.cognome} {it.nome}</span> : <span style={{ color: "#c62828" }}>⚠ non collegato</span>}
                  <div style={{ fontSize: 9, color: "#777", fontFamily: "Consolas,monospace", textTransform: "none" }}>{it.codice_fiscale || "-"}</div>
                </td>
                <td style={{ padding: "5px 8px", fontFamily: "monospace" }}>
                  {`${it.settore || ""} ${it.classe || ""}`.trim() || "—"}
                </td>
                <td style={{ padding: "3px 6px", textAlign: "center" }}>
                  <input type="text" defaultValue={it.data_inserimento} key={`di-${it.id}-${it.data_inserimento}`} data-testid={`dote-data-${i}`}
                    placeholder="gg/mm/aaaa"
                    onBlur={(e) => { const v = e.target.value.trim(); if (v !== (it.data_inserimento || "")) saveField(it, "data_inserimento", v); }}
                    style={{ width: 110, padding: "4px 6px", border: "1px solid #ddd", borderRadius: 3, fontSize: 11, textAlign: "center" }} />
                </td>
                <td style={{ padding: "3px 6px", textAlign: "right" }}>
                  <input type="text" inputMode="decimal" defaultValue={Number(it.importo || 0).toFixed(2)} key={`imp-${it.id}-${it.importo}`} data-testid={`dote-importo-${i}`}
                    onBlur={(e) => {
                      const v = parseFloat(String(e.target.value).replace(/\./g, "").replace(",", ".")) || 0;
                      if (Math.abs(v - Number(it.importo || 0)) > 0.001) saveField(it, "importo", v);
                    }}
                    style={{ width: 110, padding: "4px 6px", border: "1px solid #ddd", borderRadius: 3, fontSize: 12, textAlign: "right", fontWeight: 700, color: "#1565c0" }} />
                </td>
                <td style={{ padding: "5px 8px", textAlign: "center", whiteSpace: "nowrap" }}>
                  <button onClick={() => del(it)} data-testid={`dote-del-${i}`}
                    style={{ padding: "4px 8px", background: "#c62828", color: "white", border: "none", borderRadius: 3, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
          {!loading && rows.length > 0 && (
            <tfoot>
              <tr style={{ background: "#e3f2fd", fontWeight: 800 }}>
                <td colSpan={4} style={{ padding: "6px 8px", textAlign: "right" }}>TOTALE DOTE</td>
                <td data-testid="dote-foot-totale" style={{ padding: "6px 8px", textAlign: "right", color: "#0d47a1" }}>{fmtEuro(totale)}</td>
                <td />
              </tr>
            </tfoot>
          )}
        </table>
      </div>

      {showAdd && (
        <AddModal onClose={() => setShowAdd(false)}
          onAdded={() => { setShowAdd(false); load(); }} />
      )}
    </div>
  );
}
